/* Pie-Centro de ayuda */

//*react- recursos
  import React from "react";
  import { useHistory } from "react-router-dom"; 
  import { Col, Row } from "react-bootstrap";

//*imagenes  
  import imginegi from "../../imagenes/proyecto/INEGI_SSC_logo.png"

//*archivos
  import GeneraMenuVerticalIzq from "../../componentes/generaMenuVertical/GeneraMenuVerticalIzq";
  import menuArch from "../../datos/json/menuAyuda.json";


//*componente
  export default function Ayuda() {

    //*constantes y variables
    let history = useHistory();
    
    const regresa = () => { history.push("/PaginaSSC") }
    let menu = menuArch;
    let pasoMenu = menu;

    pasoMenu.map((opcion: any) => {
      opcion["activo"] = "f";
      return pasoMenu;
    });

    //*vista
    return (
      <>
        {/* encabezado */}
          <div className="padding-2r background-color-azul10">
            <Row>
                  <Col sm={2} className="padding-left-1r text-center centro">
                    <img src={imginegi} alt=""  />
                  </Col> 
                  <Col sm={8}>
                      <div className="text-white h3 text-center centro">Bienvenido al Centro de ayuda</div>
                  </Col> 
                  <Col sm={2}>
                        <a onClick={regresa}  className="text-white h5 text-center centro text-link2">
                        <i className='mdi mdi-arrow-left'></i> Regresar 
                        </a>
                  </Col>  
            </Row>
          </div>

        {/* <CargaArchivo /> */}
        <div className="container">
          <GeneraMenuVerticalIzq menu={pasoMenu} />
        </div>
        <br />
      
        {/* pie */}
        <div className="padding-2r background-color-gris3">
          <div className=" text-center">
            Derechos reservados © INEGI{" "}
            <a
              href="http://10.1.8.66:9095/ssc_des/doctos/Terminosycondiciones_SSC.pdf"
              target="_blank"
              rel="noreferrer"
              className="colorBlue7 "
            >
              Términos y condiciones de uso
            </a>
            <br />
            Versión 2.0
          </div>          
        </div>
      
      
      </>
    );
  }
